import React, { useEffect, useState, useMemo, useCallback } from "react";
import {
  Card, CardBody, Col, Container, CardHeader, Row, Button,
  Modal, ModalHeader, ModalBody, ModalFooter
} from 'reactstrap';
import ModalExportacaoAvancada from "../Exportacao/index";
import * as moment from "moment";
import { Link } from "react-router-dom";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import TabelaFiltroPaginacao from "../Componente/TabelaFiltroPaginacao";
import { api } from "../../../config";
import { ToastContainer } from 'react-toastify';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Loader from "../../../Components/Common/Loader";
import { fetchComAuth, fetchComAuthJson } from "../../../common/api";
import { method } from "lodash";

const TOAST_CONTAINER_ID = 'global-toaster';

const getStorageKey = (gerouVenda) => `evomap_filtros_${gerouVenda ? 'vendas' : 'reservas'}`;

const ListaReservas = ({ gerouVenda }) => {
  const [dadosReserva, setDadosReserva] = useState([]);
  const [feirasOptions, setFeirasOptions] = useState([]);
  const [error, setError] = useState(null);
  const [modal, setModal] = useState(false);
  const [etapasReserva, setEtapasReserva] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [feiraSelecionada, setFeiraSelecionada] = useState('');
  
  const [paises, setPaises] = useState([]);
  const [estados, setEstados] = useState([]);
  const [cidades, setCidades] = useState([]);
  const [pavilhao, setPavilhao] = useState([]);

  const [paisSelecionado, setPaisSelecionado] = useState('');
  const [estadoSelecionado, setEstadoSelecionado] = useState('');
  const [cidadeSelecionada, setCidadeSelecionada] = useState('');
  const [pavilhaoSelecionado, setPavilhaoSelecionado] = useState('');

  const authUser = JSON.parse(sessionStorage.getItem("authUser")) || {};
  const userData = authUser.user || authUser;
  const userType = userData.tipo || '';
  const userFeirasIds = userData.feiras?.map(item => item.feira_id) || [];
  const [isExportacaoAvancadaOpen, setIsExportacaoAvancadaOpen] = useState(false);
  const [statusSelecionado, setStatusSelecionado] = useState('');
  const [modalExcluir, setModalExcluir] = useState(false);
  const [reservaIdParaExcluir, setReservaIdParaExcluir] = useState(null);

  const STORAGE_KEY = useMemo(() => getStorageKey(gerouVenda), [gerouVenda]);

  // const toggle = useCallback(() => {
  //   if (modal) {
  //     setModal(false);
  //     setOrder(null);
  //   } else {
  //     setModal(true);
  //     setDate(defaultdate());
  //   }
  // }, [modal]);

  // ====== COLUNAS ======
  const columns = useMemo(() => [
    {
      header: "Status",
      accessorKey: "etapas",
      enableColumnFilter: true,
      enableGlobalFilter: false,
      filterFn: (row, columnId, filterValue) => {
        if (!filterValue) return true;
        const etapas = row.getValue(columnId);
        if (!etapas || etapas.length === 0) return false;
        const ultimaEtapa = etapas[etapas.length - 1].etapa_reserva?.nome || "";
        return ultimaEtapa.toLowerCase().includes(filterValue.toLowerCase());
      },
      cell: (cell) => {
        const etapas = cell.getValue();
        if (!etapas || etapas.length === 0) {
          return <span className="badge text-uppercase bg-warning-subtle text-warning">Sem Etapa</span>;
        }
        const ultimaEtapa = etapas[etapas.length - 1].etapa_reserva?.nome || "Sem Etapa";
        const getBadgeClass = (etapaNome) => {
          const etapaConfig = etapasReserva.find(e => e.nome === etapaNome);
          if (etapaConfig) {
            return etapaConfig.cor ? `bg-${etapaConfig.cor}-subtle text-${etapaConfig.cor}` : "bg-secondary-subtle text-secondary";
          }
          switch (etapaNome) {
            case "Solicitação Recebida": return "bg-info-subtle text-info";
            case "Em Análise": return "bg-primary-subtle text-primary";
            case "Aceita pelo Comercial": return "bg-success-subtle text-success";
            case "Aguardando Documentação": return "bg-warning-subtle text-warning";
            case "Em Negociação": return "bg-purple-subtle text-primary";
            case "Aguardando Pagamento": return "bg-warning-subtle text-warning";
            case "Venda Efetivada": return "bg-success-subtle text-success";
            case "Cancelada": return "bg-danger-subtle text-danger";
            case "Renovação Efetivada": return "bg-primary-subtle text-primary";
            case "Pendente Renovação": return "bg-primary-subtle text-primary";
            default: return "bg-secondary-subtle text-secondary";
          }
        };
        return <span className={`badge text-uppercase ${getBadgeClass(ultimaEtapa)}`}>{ultimaEtapa}</span>;
      },
    },
    {
      header: "Feira",
      accessorFn: (row) => row.feira?.nome || '--',
      id: 'feira_nome',
      enableColumnFilter: false,
      enableGlobalFilter: false,
      filterFn: 'exact',
      accessorKey: "feira.nome",
    },
    { id: 'estande_nome', header: "Espaço", accessorKey: "estande_detalhado.nome", filterFn: 'exact', enableGlobalFilter: true, }, // Adiciona ID e filtro 'exact'
    { id: 'pavilhao', accessorKey: 'estande_detalhado.pavilhao_nome', header: 'Pavilhão', enableGlobalFilter: false, },
    { header: "Expositor", accessorKey: "expositor.nome", enableColumnFilter: false, enableGlobalFilter: true },
    { id: 'expositor_cnpj', accessorKey: 'expositor.cnpj_codigo_internacional' , enableGlobalFilter: false,},
    { id: 'pais', accessorKey: 'expositor.pais', header: 'País', enableGlobalFilter: false, },
    { id: 'estado', accessorKey: 'expositor.estado', header: 'Estado', enableGlobalFilter: true, },
    { id: 'cidade', accessorKey: 'expositor.cidade', header: 'Cidade', enableGlobalFilter: true, },
    { header: "Vendedor", accessorKey: "comercial.nome", enableColumnFilter: false, cell: info => info.getValue() || '-', enableGlobalFilter: true, },
    {
      header: "Válido até", accessorKey: "reserva_valida_ate", enableColumnFilter: false, enableGlobalFilter: false,
      cell: (cell) => (<>{handleValidDate(cell.getValue())}, <small className="text-muted"> {handleValidTime(cell.getValue())}</small></>)
    },
    {
      header: "Atualizado em", accessorKey: "updated_at", enableColumnFilter: false, enableGlobalFilter: false,
      cell: (cell) => (<>{handleValidDate(cell.getValue())}, <small className="text-muted"> {handleValidTime(cell.getValue())}</small></>)
    },
    {
      header: "Pagamentos",
      enableColumnFilter: false,
      enableGlobalFilter: false,
      cell: (cell) => {
        const r = cell.row.original;
        return (
          <div className="d-flex flex-column small">
            <span>Forma: {r.forma_pagamento?.nome || '--'}</span>
            <span>Condição: {r.condicao_pagamento?.nome || '--'}</span>
          </div>
        );
      },
    },
    {
      header: "Ação",
      cell: (cell) => {
        const isAdmin = ['JOTAPIX', 'EVOMAP'].includes(userType);
        return (
          <ul className="list-inline hstack gap-2 mb-0">
            <li className="list-inline-item">
              {!gerouVenda ?
                <Link to={`/detalhe-reserva/${cell.row.original.id}`} className="btn btn-sm btn-success">Abrir</Link> :
                <Link to={`/detalhe-venda/${cell.row.original.id}`} className="btn btn-sm btn-success">Abrir</Link>
              }
            </li>
            {!gerouVenda && isAdmin && (
              <li className="list-inline-item">
                <button className="btn btn-sm btn-danger" onClick={() => deletar(cell.row.original.id)}>Excluir</button>
              </li>
            )}
          </ul>
        );
      },
    },
  ], [etapasReserva, gerouVenda, userType]);

  const defaultdate = () => {
    let d = new Date(),
      months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    let h = (d.getHours() % 12) || 12;
    let ampm = d.getHours() < 12 ? "AM" : "PM";
    return ((d.getDate() + ' ' + months[d.getMonth()] + ', ' + d.getFullYear() + ", " + h + ":" + d.getMinutes() + " " + ampm).toString());
  };

  const [date, setDate] = useState(defaultdate());

  const handleValidDate = date => moment(new Date(date)).format("DD/MM/YYYY");
  const handleValidTime = (time) => {
    const time1 = new Date(time);
    const getHour = time1.getUTCHours();
    const getMin = time1.getUTCMinutes();
    const getTime = `${getHour}:${getMin}`;
    const meridiem = getHour >= 12 ? "PM" : "AM";
    return moment(getTime, 'hh:mm').format('hh:mm') + " " + meridiem;
  };

  useEffect(() => {
    try {
      const saved = JSON.parse(sessionStorage.getItem(STORAGE_KEY));
      if (saved) {
        setFeiraSelecionada(saved.feiraSelecionada ?? '');
        setPaisSelecionado(saved.paisSelecionado ?? '');
        setEstadoSelecionado(saved.estadoSelecionado ?? '');
        setCidadeSelecionada(saved.cidadeSelecionada ?? '');
        setPavilhaoSelecionado(saved.pavilhaoSelecionado ?? '');
        setStatusSelecionado(saved.statusSelecionado ?? '');
      }
    } catch { /* ignore */ }
  }, [STORAGE_KEY]);

  useEffect(() => {
    const payload = {
      feiraSelecionada, paisSelecionado, estadoSelecionado,
      cidadeSelecionada, pavilhaoSelecionado, statusSelecionado
    };
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
  }, [
    STORAGE_KEY,
    feiraSelecionada, paisSelecionado, estadoSelecionado,
    cidadeSelecionada, pavilhaoSelecionado
  ]);

  useEffect(() => {
    const fetchFeiras = async () => {
      try {
        const response = await fetchComAuth(`${api.API_URL}/feiras/`, { method: 'GET' });
        if (!response.ok) throw new Error("Erro na resposta da API de feiras");
        const data = await response.json();

        if (data && data.data) {
          const feirasDoUsuario = ['JOTAPIX', 'EVOMAP'].includes(userType)
            ? data.data
            : data.data.filter(f => f.id && userFeirasIds.includes(f.id));

          const options = feirasDoUsuario
            .map(f => ({ value: f.id, label: f.nome }))
            .sort((a, b) => a.label.localeCompare(b.label));

          setFeirasOptions(options);

          if (!['JOTAPIX', 'EVOMAP', 'ORGANIZACAO'].includes(userType)) {
            if (options.length === 1 && !feiraSelecionada) {
              setFeiraSelecionada(options[0].value);
            }
          }
        }
      } catch (error) {
        console.error("Erro ao buscar feiras:", error);
        setError("Erro ao carregar lista de feiras");
      }
    };
  
    fetchFeiras();
    
  }, [feiraSelecionada]);

  useEffect(() => {
    const carregarDadosFeira = async () => {
      if (!feiraSelecionada) {
        setPaises([]);
        setPavilhao([]);
        return;
      }
      try {
        const respPaises = await fetchComAuth(`${api.API_URL}/paises`, { method: 'GET' });
        const dataPaises = await respPaises.json();
        setPaises(dataPaises.data || []);
      } catch (err) { console.error("Erro ao carregar países:", err); }

      try {
        const respPav = await fetchComAuth(`${api.API_URL}/feira/pavilhao_feira/${feiraSelecionada}`, { method: 'GET' });
        const dataPav = await respPav.json();
        setPavilhao(dataPav.data || []);
      } catch (err) { console.error("Erro ao carregar pavilhões:", err); }
    };

    carregarDadosFeira();
  }, [feiraSelecionada]);

  useEffect(() => {
    const carregarEstados = async () => {
      if (paisSelecionado === 'BR') {
        try {
          const response = await fetch(`${api.API_URL}/estados`, {
            headers: { chave: "18266602-6085-4532-992d-7bc2750b19f4" }
          });
          const estados = await response.json();
          setEstados(estados.data || []);
        } catch (error) {
          console.error("Erro ao carregar estados:", error);
        }
      } else {
        setEstados([]);
        setEstadoSelecionado('');
      }
    };
    carregarEstados();
  }, [paisSelecionado]);

  useEffect(() => {
    const carregarCidades = async () => {
      if (estadoSelecionado) {
        try {
          const response = await fetch(`https://servicodados.ibge.gov.br/api/v1/localidades/estados/${estadoSelecionado}/municipios`);
          const cidades = await response.json();
          setCidades(cidades.map(c => ({ id: c.id, nome: c.nome })) || []);
        } catch (error) {
          console.error("Erro ao carregar cidades:", error);
        }
      } else {
        setCidades([]);
        setCidadeSelecionada('');
      }
    };
    carregarCidades();
  }, [estadoSelecionado]);

  useEffect(() => {
    const fetchReservas = async () => {
      if (!feiraSelecionada) { setDadosReserva([]); return; }
      
      const isAdministrativo = ['JOTAPIX', 'EVOMAP', 'ORGANIZACAO'].includes(userType);
      if (!isAdministrativo && feirasOptions.length > 1 && !feiraSelecionada) {
        setDadosReserva([]);
        return;
      }

      setIsLoading(true);

      try {
        const url_base = isAdministrativo ? 'reservas' : `reserva/comercial`;
        const url_final = `${api.API_URL}/${url_base}/${feiraSelecionada}`;

        const response = await fetchComAuth(url_final, { method: 'GET' });
        
        if (!response.ok) throw new Error("Erro ao buscar os dados");
        
        
        const  responseData = await response.json();
        const todasReservas = responseData.data || [];
        
        const reservasFiltradas = todasReservas.filter(f => f.gerou_venda == gerouVenda);
      
        setDadosReserva(reservasFiltradas);
        setError(null);
      } catch (error) {
        setError(error.message);
      } finally {
        setIsLoading(false);
      }
    };
    fetchReservas();
  }, [feiraSelecionada, gerouVenda, userType, userData.id, feirasOptions.length]);

  const deletar = async (id) => {
    setReservaIdParaExcluir(id);
    setModalExcluir(true);
  };

  const confirmarExclusao = async () => {
    setModalExcluir(false);
    if (!reservaIdParaExcluir) return;
    setIsLoading(true);
    try {
      const response = await fetchComAuthJson(`${api.API_URL}/reserva/${reservaIdParaExcluir}`, { method: 'DELETE' });
      if (!response.ok) throw new Error();
      toast.success("Reserva deletada com sucesso.");
      setDadosReserva(dadosReserva.filter(reserva => reserva.id !== reservaIdParaExcluir));
      setError(null);
    } catch (e) {
     // console.log(e);
      toast.error("Erro ao deletar reserva.");
    } finally {
      setIsLoading(false);
      setReservaIdParaExcluir(null);
    }
  };

  const handleFeiraChange = (novaFeiraId) => {
    setFeiraSelecionada(novaFeiraId || '');
    if (!novaFeiraId) {
      setPaisSelecionado('');
      setEstadoSelecionado('');
      setCidadeSelecionada('');
      setPavilhaoSelecionado('');
    }
  };

  const dadosFiltrados = useMemo(() => {
    if (!statusSelecionado) return dadosReserva;

    return dadosReserva.filter(item => {
      const etapas = item.etapas || [];
      if (etapas.length === 0) return false;
      const ultimaEtapa = etapas[etapas.length - 1].etapa_reserva?.nome || "";
      return ultimaEtapa === statusSelecionado;
    });
  }, [dadosReserva, statusSelecionado]);

  document.title = `${!gerouVenda ? "Reservas" : "Vendas"} | EVOMAP - Tecnologia que conecta negócios`;

  const ModalConfirmacaoExclusao = () => (
    <Modal isOpen={modalExcluir} toggle={() => setModalExcluir(false)} centered>
      <ModalHeader toggle={() => setModalExcluir(false)}>Confirmação de Exclusão</ModalHeader>
      <ModalBody><p>Tem certeza de que deseja excluir esta reserva?</p></ModalBody>
      <ModalFooter>
        <Button color="light" onClick={() => setModalExcluir(false)}>Cancelar</Button>
        <Button color="danger" onClick={confirmarExclusao}>Excluir</Button>
      </ModalFooter>
    </Modal>
  );

  const memoizedStatusOptions = useMemo(() => ([
    "Solicitação Recebida", "Em Análise", "Aceita pelo Comercial",
    "Aguardando Documentação", "Em Negociação", "Aguardando Pagamento",
    "Venda Efetivada", "Cancelada", "Prorrogar Reserva", "Renovação Efetivada",
    "Pendente Renovação"
  ]), []);

  return (
    <div className="page-content">
      <ToastContainer containerId={TOAST_CONTAINER_ID} position="top-right" newestOnTop closeButton={false} />
      {ModalConfirmacaoExclusao()}

      <Container fluid>
        <BreadCrumb title={!gerouVenda ? "Reservas" : "Vendas"} pageTitle={`${!gerouVenda ? "Reservas" : "Vendas"} - EVOMAP`} />
        <Row>
          <Col lg={12}>
            <Card id="orderList">
              <CardHeader className="border-0">
                <Row className="align-items-center gy-1">
                  <div className="col-sm">
                    <h5 className="card-title mb-0">Lista de {gerouVenda ? ' Vendas' : ' Reservas'}</h5>
                  </div>
                  <div className="col-sm-auto">
                    <div className="d-flex gap-1 flex-wrap">{/* Ações extras se precisar */}</div>
                  </div>
                </Row>
              </CardHeader>

              <CardBody>
                <div>
                  {isLoading ? (
                    <Loader />
                  ) : error ? (
                    <Loader error={error} />
                  ) : (
                    <TabelaFiltroPaginacao
                      columns={columns}
                      data={dadosFiltrados}
                      isGlobalFilter={true}
                      customPageSize={10}
                      tableclassName="align-middle"
                      theadclassName="table-light text-muted"
                      divClassName="table-responsive table-card mb-1"
                      nomeRelatorio={!gerouVenda ? "Reservas" : "Vendas"}
                      SearchPlaceholder="Pesquise por espaço, expositor, vendedor, cidade ou estado..."
                      hiddenColumns={!gerouVenda ? ['expositor_cnpj', 'Status'] : ['expositor_cnpj', 'Feira', 'Status']}

                      feirasOptions={feirasOptions}
                      feiraSelecionada={feiraSelecionada}
                      onFeiraChange={handleFeiraChange}

                      paisesOptions={paises}
                      paisSelecionado={paisSelecionado}
                      onPaisChange={setPaisSelecionado}

                      estadosOptions={estados}
                      estadoSelecionado={estadoSelecionado}
                      onEstadoChange={setEstadoSelecionado}

                      cidadesOptions={cidades}
                      cidadeSelecionada={cidadeSelecionada}
                      onCidadeChange={setCidadeSelecionada}

                      pavilhoesOptions={pavilhao}
                      pavilhaoSelecionado={pavilhaoSelecionado}
                      onPavilhaoChange={setPavilhaoSelecionado}

                      dashboard={false}
                      statusOptions={memoizedStatusOptions}

                      statusSelecionado={statusSelecionado}
                      onStatusChange={setStatusSelecionado}
                    />
                  )}
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>

      <ModalExportacaoAvancada
        isOpen={isExportacaoAvancadaOpen}
        toggle={() => setIsExportacaoAvancadaOpen(false)}
        data={dadosReserva}
        feiraNome={""}
        statusOptions={!gerouVenda ? [
          "Solicitação Recebida", "Em Análise", "Aceita pelo Comercial",
          "Aguardando Documentação", "Em Negociação", "Aguardando Pagamento",
          "Cancelada", "Em Negociação", "Prorrogar Reserva", "Renovação Efetivada",
          "Pendente Renovação"
        ] : []}
      />
    </div>
  );
};

export default ListaReservas;
